import React, { useCallback } from 'react'
import './condition-step-node.scss'
import { Handle, NodeProps, NodeToolbar, Position } from '@xyflow/react'
import { getEdgeId } from '../../helpers'
import { JourneyNodeIcon } from '../custom-node/journey-node-icon'
import { JourneyNodeLabel } from '../custom-node/journey-node-label'
import { getClassNames } from '../../../../_utils/classnames'
import { useJourneyContext } from '../../context'
import { JourneyNode } from '../../types/journey-nodes'
import type { IConditionalStep } from '@pushly/models/lib/structs/journeys'
import { InvalidJourneyComponent } from '../../edge-types/custom-edge/invalid-journey-component'
import { JourneyNodeInteractionActions } from '../custom-node/journey-node-interaction-actions'
import { JourneyAction } from '../../types/journey-context'

const BRANCH_KEYS = ['yes', 'no'] as const

export const ConditionStepNode = ({ id, data, targetPosition, sourcePosition }: NodeProps<JourneyNode<IConditionalStep>>) => {
    const [, dispatch] = useJourneyContext()

    const handleNodeBodyClick = useCallback(() => {
        dispatch({ action: JourneyAction.CLOSE_ALL_POPOVERS })
    }, [dispatch])

    return (
        <React.Fragment>
            <Handle type="target" position={targetPosition ?? Position.Top} id={getEdgeId(id)} />
            <NodeToolbar isVisible={!!data.uiMeta.invalid} position={Position.Left} className="journey-invalid-label">
                <InvalidJourneyComponent content={data.uiMeta.invalid?.reason} />
            </NodeToolbar>
            <div
                className={getClassNames(
                    null,
                    'custom-node-wrapper type-condition',
                    { invalid: data.uiMeta.invalid },
                )}
                onClick={handleNodeBodyClick}
            >
                <div className="custom-node-border" />
                <div className={getClassNames(null, 'custom-node', 'no-drag')}>
                    <JourneyNodeIcon id={id} node={data.step} />
                    <JourneyNodeLabel node={data.step} />
                    <JourneyNodeInteractionActions nodeId={id} />
                </div>
            </div>
            {BRANCH_KEYS.map((key, idx) => {
                const leftPercent = ((idx + 1) / (BRANCH_KEYS.length + 1)) * 100

                return (
                    <Handle
                        key={key}
                        type="source"
                        position={sourcePosition ?? Position.Bottom}
                        id={`branch-${key}`}
                        style={{ left: `${leftPercent}%` }}
                    />
                )
            })}
        </React.Fragment>
    )
}
